import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ManifestoSection from './components/ManifestoSection';
import ProductionSection from './components/ProductionSection';
import FarmingSection from './components/FarmingSection';
import VersatilitySection from './components/VersatilitySection';
import TasteSection from './components/TasteSection';
import MarketSection from './components/MarketSection';
import WholesaleCta from './components/WholesaleCta';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="w-full overflow-x-hidden">
      <Navbar />

      {/* Hero with iPhone scroll animation */}
      <HeroSection />

      {/* About / Who We Are */}
      <ManifestoSection />

      {/* Our Services - horizontal scroll */}
      <ProductionSection />

      {/* Team */}
      <FarmingSection />

      {/* Three pillars */}
      <VersatilitySection />

      {/* Values */}
      <TasteSection />

      {/* Our Products */}
      <MarketSection />

      {/* Contact */}
      <WholesaleCta />

      <Footer />
    </main>
  );
}
